import type { IconSvgObject } from './types';

const EqualNotIcon: IconSvgObject = [
  ["path", { d: "M5 15H19M5 9H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 4L5 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EqualNotIcon;
